import React from 'react';
import {useTranslation} from 'react-i18next';
import {useRulesStore} from '../rules.store';
import SectionWrapper from './section-wrapper';

const FAQSection: React.FC = () => {
  const {t} = useTranslation();
  const {faqItems} = useRulesStore();

  return (
    <SectionWrapper title={t('agent.rules.faq.title')}>
      <div className="space-y-3">
        {faqItems.map((item, index) => (
          <div key={index} className="space-y-2">
            {/* 问题 */}
            <h3 className="text-base font-medium text-t1">{item.question}</h3>

            {/* 答案 */}
            <p className="text-sm text-t2 leading-normal">{item.answer}</p>

            {/* 分割线（除了最后一个） */}
            {index < faqItems.length - 1 && (
              <div className="h-px bg-[rgba(72,80,93,0.2)]" />
            )}
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
};

export default FAQSection;
